import { render } from "./Notifications.vue?vue&type=template&id=7d43e8ae&scoped=true"
const script = {}

import "./Notifications.vue?vue&type=style&index=0&id=7d43e8ae&scoped=true&lang=css"

import exportComponent from "/opt/render/project/src/sb.web.app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d43e8ae"]])

export default __exports__